export const TIPO_ORIGEN = 1;
export const TIPO_DESTINO = 2;
export const TIPO_AMBOS = 3;

export const UbicacionHelper = {
    TIPO_ORIGEN,
    TIPO_DESTINO,
    TIPO_AMBOS,
};